import PurchasesService from '@services/purchases-service.js'

export const state = {
    baskets: [],
    activities: [],
}

export const mutations = {
    SET_BASKET(state, { baskets }) {
        state.baskets = baskets
    },
    SET_ACTIVITIES(state, { activities }) {
        state.activities = activities
    },
    UPDATE_ACTIVITIES(state, { activities }) {
        state.activities = [...state.activities, ...activities]
    },
    REMOVE_ACTIVITIES(state) {
        state.activities = []
    },
}

export const getters = {
    baskets: state => state.baskets,
    activities: state => state.activities,
}

export const actions = {
    async getBaskets({ commit, rootGetters, dispatch }) {
        const baskets = await PurchasesService.getStoreBaskets({
            storeId: rootGetters['stores/selectedStoreId'],
        })

        await dispatch('customers/getStoreVisitors', null, { root: true })

        commit('SET_BASKET', baskets)

        return baskets
    },

    updateActivities({ commit }, { activities }) {
        commit('UPDATE_ACTIVITIES', { activities })

        return activities
    },

    removeActivities({ commit }) {
        commit('REMOVE_ACTIVITIES')
    },

    updateStoreActivity({ commit, state }, { activity, reverse }) {
        commit('SET_ACTIVITIES', {
            activities: reverse
                ? [...state.activities, activity]
                : [activity, ...state.activities],
        })
    },

    updateActivity({ commit, getters }, { activity }) {
        commit('SET_ACTIVITIES', {
            activities: getters.activities.map(localActivity => {
                if (localActivity._id === activity._id) return activity
                return localActivity
            }),
        })
    },

    removeActivity({ commit, getters }, { activity }) {
        commit('SET_ACTIVITIES', {
            activities: getters.activities.filter(localActivity => {
                if (localActivity._id === activity._id) return false
                return localActivity
            }),
        })
    },

    updateBasket({ commit, getters }, { basket }) {
        const localBasketId = basket.id || basket._id
        commit('SET_BASKET', {
            baskets: getters.baskets.map(prevBasket => {
                if (prevBasket._id === localBasketId) {
                    return basket
                }

                return prevBasket
            }),
        })
    },

    createBasket({ commit, getters }, { basket }) {
        commit('SET_BASKET', {
            baskets: [...getters.baskets, basket],
        })
    },

    removeBasket({ commit, getters }, { basket }) {
        const localBasketId = basket.id || basket._id
        commit('SET_BASKET', {
            baskets: getters.baskets.filter(prevBasket => {
                if (prevBasket._id === localBasketId) {
                    return false
                }

                return prevBasket
            }),
        })
    },
}
